export interface ConversationSelection {
  id: string;
  isDraft: boolean;
}

export function createDraftConversationSelection(
  generateId: () => string,
): ConversationSelection {
  return { id: generateId(), isDraft: true };
}

export function selectExistingConversation(id: string): ConversationSelection {
  return { id, isDraft: false };
}

export function shouldLoadConversationHistory(
  selection: ConversationSelection,
): boolean {
  return !selection.isDraft && selection.id.length > 0;
}
